<ngx-skeleton-loader *ngIf="isLoading; else isLoaded" count="1" [theme]="{height: '90px', width: '100%'}"></ngx-skeleton-loader>

<ng-template #isLoaded>
  <ng-container>
    <div class="db-card">
      <div class="db-card-header">
        <div>
          <p class="db-card-title fw-600 text-size-20">{{ moduleSetting.heading }}</p>
          <p class="text-size-14 fw-500 text-color-light-2 mt-1" *ngIf="moduleSetting.subheading">{{ moduleSetting.subheading }}</p>
        </div>
      </div>
      <div class="db-card-body m-0">
        <ng-container>
          <div class="flex-box-lg-center-between mt-3">
            <div>
              <lib-vendor-details *ngIf="moduleSetting.vendor; let vendor" [vendor]="vendor"></lib-vendor-details>
            </div>
            <div class="mt-auto">
              <button
                class="whitespace-nowrap ml-auto button-mid"
                [ngClass]="{'button-primary': moduleSetting.button.type === DashboardModuleButtonType.SECONDARY}"
                libDashboardTrackButtonClick
                (click)="performCTAAction(moduleSetting.button.action)"
              >
                {{ moduleSetting.button.label }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>
